// @ts-nocheck
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import ScalingFrame from '../components/layout/ScalingFrame';
import Sidebar from '../components/layout/Sidebar';
import TopBar from '../components/layout/TopBar';
import HomeApp from './HomeApp';
import './HomePage.css';

export default function HomePage() {
  const navigate = useNavigate();
  const authData = useAuth();
  const isLoggedIn = Boolean(authData?.IS_LOGGED_IN);

  const openConsole = () => navigate('/admissions/v2');
  const openDemo = () => navigate('/admissions/live-demo');

  return (
    <div className="frame-shell home-shell">
      <ScalingFrame>
        <Sidebar activeId="home" locked={!isLoggedIn} />
        <TopBar
          crumbTitle="Welcome"
        />
        <div className="work home-work">
          <HomeApp onOpenConsole={openConsole} onOpenDemo={openDemo} />
        </div>
      </ScalingFrame>
    </div>
  );
}
